var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",style:({ fontSize: (_vm.size + "px") }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":("#" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }